import React, { useCallback, useState } from "react";
import { Form, Input, Select } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { filterOptions } from "./variables";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE, USER_TENANT_NAME } from "utils/constants";
import { uniq } from "lodash";
import { useSelector } from "react-redux";
import { DictionariesSelector } from "store/dictionaries/selectors";
import { getSearchObj } from "pages/warehouse/customerCards/utils";
const { Option } = Select;

const CustomerCardsFilter = ({ onFilter }) => {
  const [form] = Form.useForm();
  const { getFilters } = useStoreFilters(FILTER_PAGE.CUSTOMER_CARDS);
  const [activeFilter, setFilter] = useState(null);

  const {
    list: { depot },
  } = useSelector(DictionariesSelector);

  const handleFilterChange = useCallback(
    value => {
      setFilter(value);
      form.setFieldsValue({
        value: null,
        range: null,
      });
    },
    [form]
  );

  const onFinish = useCallback(values => {
    const { pageSize } = getFilters();
    const searchObj = !!values?.type ? getSearchObj(values) : { group: "Card" };
    onFilter({ ...searchObj, pageSize });
  }, []);

  return (
    <>
      <div className="custom-filter">
        <Form form={form} name="horizontal_login" layout="inline" onFinish={onFinish}>
          <Form.Item name="type">
            <Select
              showSearch
              style={{ width: "100%" }}
              tokenSeparators={[","]}
              size="default"
              placeholder="Select type"
              allowClear
              onChange={handleFilterChange}
            >
              {filterOptions.map(item => (
                <Option key={item} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {activeFilter === "depot" && (
            <>
              <div className="filter-divider" />
              <Form.Item name="value">
                <Select showSearch placeholder={"Select value"}>
                  {depot[USER_TENANT_NAME()] &&
                    uniq(depot[USER_TENANT_NAME()])
                      ?.sort()
                      ?.map(item => (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </>
          )}
          {activeFilter === "type" && (
            <>
              <div className="filter-divider" />
              <Form.Item name="value">
                <Select showSearch placeholder={"Select value"}>
                  {["RFID Card", "Virtual Card"].map(item => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}
          {activeFilter === "state" && (
            <>
              <div className="filter-divider" />
              <Form.Item name="value">
                <Select showSearch placeholder={"Select value"}>
                  {["Available", "In Use", "Retired", "Assigned", "Collected", "Lost"].map(item => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}

          {activeFilter === "cardNumber" && (
            <>
              <div className="filter-divider" />
              <Form.Item name="value">
                <Input placeholder="Enter value" allowClear />
              </Form.Item>
            </>
          )}

          <CustomButton type="primary" htmlType="submit" text="Filter" size="small" />
        </Form>
      </div>
    </>
  );
};

export default CustomerCardsFilter;
